import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Mobile web "keyboard up" detection: rather than relying on
// visualViewport (iOS Safari's height doesn't always shrink), toggle
// body.keyboard-open whenever a text input or textarea has focus. The
// bottom nav CSS keys off this class to hide while typing.
if (typeof document !== 'undefined') {
  const isTextField = (el) =>
    el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
  document.addEventListener('focusin', (e) => {
    if (isTextField(e.target)) document.body.classList.add('keyboard-open');
  });
  document.addEventListener('focusout', (e) => {
    // Defer one tick — the next focus may be another text field, in
    // which case we don't want a flicker.
    setTimeout(() => {
      if (!isTextField(document.activeElement)) {
        document.body.classList.remove('keyboard-open');
      }
    }, 0);
  });

  // Track keyboard height too if visualViewport is available; gives
  // useful pixels for the chat-input rise on Android Chrome where the
  // viewport actually shrinks.
  if (window.visualViewport) {
    const sync = () => {
      const kb = Math.max(0, Math.round(window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop));
      document.body.style.setProperty('--keyboard-height', `${kb}px`);
    };
    window.visualViewport.addEventListener('resize', sync);
    window.visualViewport.addEventListener('scroll', sync);
    sync();
  }
}

// StrictMode belongs in dev only. Its whole purpose is exposing lifecycle
// bugs by intentionally double-invoking effects, refs, and state
// initializers — behavior real users should never see. Under React 19
// that double-mount is what surfaced the Supabase channel bugs in
// commits 003cbe6 / 47e5da9; keeping StrictMode in production turned
// every latent double-mount bug into a live incident. Dev still gets
// the detection.
const root = ReactDOM.createRoot(document.getElementById('root'));
const app = <App />;
root.render(
  process.env.NODE_ENV === 'production'
    ? app
    : <React.StrictMode>{app}</React.StrictMode>
);
